module.exports = __webpack_public_path__ + "12630ff4d3b7fca0fca07f0174fa7036.svg";